<template>
    <div>
        <div class="">
            <div class="tableContainer">
                <div class="sampleTemplate" :class="{'hideItem' : (getUser == null || getUser.roleName != $role.ADMIN)}">
                    <b-table
                        id="table1"
                        ref="table1"
                        :fields="fields"
                        :items="getBoard"
                        :per-page="perPage"
                        :current-page="currentPage"
                        @row-selected="onRowSelected"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        select-mode="multi"
                        selectable
                        show-empty
                        empty-text="FAQ글이 존재하지 않습니다."
                        >
                        <template #emptyfiltered="scope">
                            <h4>{{ scope.emptyFilteredText }}</h4>
                        </template>
                        <template #cell(selected)="{ rowSelected }">
                            <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                            </template>
                            <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                            </template>
                        </template>
                        <template #cell(QUESTION)="data">
                            <span v-html="data.value" @click="showDetail(data.item.IDX)"></span>
                        </template>
                    </b-table>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalCnt"
                        :per-page="perPage"
                        aria-controls="table">
                    </b-pagination>
                </div>

                <div class="sampleTemplate" :class="{'hideItem': (getUser != null && getUser.roleName == $role.ADMIN)}">
                    <b-table 
                        id="table2"
                        ref="table2"
                        :fields="fields"
                        :items="getBoard"
                        :per-page="perPage"
                        :current-page="currentPage"
                        @row-clicked="onRowClicked"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        show-empty
                        hover
                        empty-text="FAQ글이 존재하지 않습니다."
                        >
                        <template #emptyfiltered="scope">
                            <h4>{{ scope.emptyFilteredText }}</h4>
                        </template>
                        <template #cell(QUESTION)="data">
                            <div class="flex">
                                <span class="QIcon"></span>
                                <span v-html="data.value" class="QTxt"></span>
                            </div>
                        </template>
                        <template #row-details="row">
                            <b-card>
                                <b-row class="mb-2">
                                    <b-col sm="3" class="text-sm-right"><span class="AIcon"></span></b-col>
                                    <b-col v-html="row.item.ANSWER" class="text-sm-left"></b-col>
                                </b-row>
                            </b-card>
                        </template>
                    </b-table>
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="totalCnt"
                    :per-page="perPage"
                    aria-controls="table">
                    </b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed:{
        ...mapGetters('auth', [
            'getUser' 
        ]),
    },
    beforeCreated(){
        this.setDataTable();
    },
    data() {
        return {
            searchText:this.$route.query.searchText,
            selected: [],
            perPage: 10,
            currentPage: 1,
            totalCnt: 0,
            sortBy: 'IDX',
            sortDesc: false,
            fields: [],
            items: [],
            routerName : ""
        }
    },
    methods:{
        onRowClicked(item){
            item._showDetails = !item._showDetails;
        },
        onRowSelected(items) {
            this.selected = items;
        },
        showDetail(idx){
            let routerName = this.$store.state.board.routerName;
            this.$router.push({ name: routerName, params: { idx: idx, searchText: this.$route.query.searchText }});
        },
        getBoard(ctx, callback){
            let searchText = this.$route.query.searchText;
            let boardObj = {
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                searchText : searchText
            };

            this.$store.dispatch('board/getBoardList', boardObj).then((data) => {
                this.setDataTable();
                
                for(let i = 0; i < data.data.items.length; i++){
                    data.data.items[0].ANSWER = data.data.items[0].ANSWER.replace(/(?:\r\n|\r|\n)/g, '<br />');
                }

                callback(data.data.items);
            });

            return null;
        },
        setDataTable(){
            this.currentPage = this.$store.state.board.currentPage;
            this.perPage = this.$store.state.board.perPage;
            this.totalCnt = this.$store.state.board.totalCnt;
            this.sortBy = this.$store.state.board.sortBy;
            this.sortDesc = this.$store.state.board.sortDesc;
            this.fields = this.$store.state.board.fields;
        },
        setContent(value){
            if(value){
                let content = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
                return `<span class="AIcon">A.</span><div v-html='${content}'><div/>`
            }
        },
    }
}
</script>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
    .hideItem{
        display: none;
    }
</style>

<style scoped>
    .faqBoard .sampleTemplate .card {
        background-color: #FEFCFC;
    }
    .faqBoard .sampleTemplate .table-hover > tbody > tr:hover {
        background: transparent;
        --bs-table-accent-bg: transparent;
    }
</style>